import * as React from "react";
import * as i18next from "i18next";
import * as Utils from "@Cyclope-Utils/index";
import Stream from "@tunnel-components/@sharded/widgets/stream/component";
import Scrollbars from "@tunnel-components/@sharded/@widgets/scrollbars";
import StyledIcon from "@tunnel-components/@sharded/@widgets/icons/component";
import * as Styled from "@tunnel-components/@sharded/@styled/styled";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { data, positionVehicule, params, viewSnapshot } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <div className="smallCart-Cart">
      <div className="smallSnapshot">
        <div
          className="viewSnapshot btnSecondary"
          onClick={viewSnapshot}
          style={{ border: "none" }}
        >
          <Styled.Icon style={{ width: "30px" }}>
            <StyledIcon explorer={true} color="white" />
          </Styled.Icon>
        </div>
        <Stream
          localUrl={data.snapshot}
          name={data.camera ? data.camera.code : undefined}
        />
      </div>
      <div className="smallTextcart-p">
        <Scrollbars height="100%" width="100%">
          <div className="autoSettings">
            <p>
              {i18next.t("incident")} :{" "}
              <span> {`${i18next.t(`${data.label}`)} #${params}`}</span>
            </p>
            <p>
              {i18next.t("camera")} :{" "}
              {data.camera ? data.camera.code : undefined}
            </p>
            {!!positionVehicule && (
              <p>
                {" "}
                {i18next.t("position de l'incident")} : {positionVehicule}
              </p>
            )}
            <p>
              {i18next.t("pk de la camera")} :{" "}
              {data.camera ? data.camera.location : undefined}
            </p>
            <p>
              {i18next.t("pk de l'incident")} :{" "}
              {data.camera && data.camera.view !== "approche"
                ? Number(data.camera.location) + Number(data.vehicleDistance)
                : Number(data.camera.location) - Number(data.vehicleDistance)}
            </p>
            <p>
              {i18next.t("date de l'incident")} :{" "}
              {Utils.localDateFrFormat(data.startTime)}
            </p>
            <p>
              {i18next.t("duree de l'incident (sec)")} : {data.duration}
            </p>
          </div>
        </Scrollbars>
      </div>
    </div>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  authorization: boolean;
  data: any;
  positionVehicule?: any;
  params?: any;
  viewSnapshot?: any;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/small-incident-cart/component.tsx